/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCaseTransaction } from './InternalApiCaseTransaction';
import {
    InternalApiCaseTransactionFromJSON,
    InternalApiCaseTransactionFromJSONTyped,
    InternalApiCaseTransactionToJSON,
    InternalApiCaseTransactionToJSONTyped,
} from './InternalApiCaseTransaction';

/**
 * 
 * @export
 * @interface InternalApiCaseTransactionPage
 */
export interface InternalApiCaseTransactionPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseTransactionPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseTransactionPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseTransactionPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiCaseTransaction>}
     * @memberof InternalApiCaseTransactionPage
     */
    content: Array<InternalApiCaseTransaction>;
}

/**
 * Check if a given object implements the InternalApiCaseTransactionPage interface.
 */
export function instanceOfInternalApiCaseTransactionPage(value: object): value is InternalApiCaseTransactionPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCaseTransactionPageFromJSON(json: any): InternalApiCaseTransactionPage {
    return InternalApiCaseTransactionPageFromJSONTyped(json, false);
}

export function InternalApiCaseTransactionPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseTransactionPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiCaseTransactionFromJSON)),
    };
}

export function InternalApiCaseTransactionPageToJSON(json: any): InternalApiCaseTransactionPage {
    return InternalApiCaseTransactionPageToJSONTyped(json, false);
}

export function InternalApiCaseTransactionPageToJSONTyped(value?: InternalApiCaseTransactionPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiCaseTransactionToJSON)),
    };
}

